import { render } from "./CButtonSecondary.vue?vue&type=template&id=628ec4bc&scoped=true"
const script = {}

import "./CButtonSecondary.vue?vue&type=style&index=0&id=628ec4bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628ec4bc"]])

export default __exports__